<template>
  <div class="d-flex p-20 justify-content-center">

    <div class="p-3 bg-white container br-8">
      <div class="alert alert-danger pt-4 m-0">
        <p><strong><i class="lh-inherit far fa-info-circle"></i> {{ translate('Task not found') }}</strong></p>
      </div>
    </div>


  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "JobNotFound",
  props: {},
  components: {},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
